import React, { useEffect, useState } from 'react'
import { Icon } from '@iconify/react';
import { dashboardService } from '../../services/api';

const UnitCountOne = () => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadStats();
    }, []);

    const loadStats = async () => {
        try {
            setLoading(true);
            const response = await dashboardService.getStats();
            if (response.success && response.data) {
                setStats(response.data);
            }
        } catch (error) {
            console.error('Error loading stats:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading || !stats) {
        return (
            <div className="row row-cols-xxxl-5 row-cols-lg-3 row-cols-sm-2 row-cols-1 gy-4">
                {[1, 2, 3, 4, 5, 6].map((i) => (
                    <div key={i} className="col">
                        <div className="card shadow-none border bg-gradient-start-1 h-100">
                            <div className="card-body p-20">
                                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                    <div>
                                        <p className="fw-medium text-primary-light mb-1">Yükleniyor...</p>
                                        <h6 className="mb-0">-</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className="row row-cols-xxxl-5 row-cols-lg-3 row-cols-sm-2 row-cols-1 gy-4">
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-1 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Toplam Kullanıcılar</p>
                                <h6 className="mb-0">{stats.totalUsers?.toLocaleString('tr-TR') || 0}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-cyan rounded-circle d-flex justify-content-center align-items-center">
                                <Icon
                                    icon="gridicons:multiple-users"
                                    className="text-white text-2xl mb-0"
                                />
                            </div>
                        </div>
                        <p className="fw-medium text-sm text-primary-light mt-12 mb-0 d-flex align-items-center gap-2">
                            {stats.totalUsersPercent !== 0 && (
                                <span className={`d-inline-flex align-items-center gap-1 ${stats.totalUsersPercent >= 0 ? 'text-success-main' : 'text-danger-main'}`}>
                                    <Icon icon={stats.totalUsersPercent >= 0 ? "bxs:up-arrow" : "bxs:down-arrow"} className="text-xs" />
                                    {Math.abs(stats.totalUsersPercent)}%
                                </span>
                            )}
                            <span>Son 30 güne göre değişim</span>
                        </p>
                    </div>
                </div>
            </div>
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-2 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Organizasyonlar</p>
                                <h6 className="mb-0">{stats.totalOrganizations?.toLocaleString('tr-TR') || 0}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-purple rounded-circle d-flex justify-content-center align-items-center">
                                <Icon
                                    icon="fa-solid:award"
                                    className="text-white text-2xl mb-0"
                                />
                            </div>
                        </div>
                        <p className="fw-medium text-sm text-primary-light mt-12 mb-0 d-flex align-items-center gap-2">
                            {stats.totalOrganizationsPercent !== 0 && (
                                <span className={`d-inline-flex align-items-center gap-1 ${stats.totalOrganizationsPercent >= 0 ? 'text-success-main' : 'text-danger-main'}`}>
                                    <Icon icon={stats.totalOrganizationsPercent >= 0 ? "bxs:up-arrow" : "bxs:down-arrow"} className="text-xs" />
                                    {Math.abs(stats.totalOrganizationsPercent)}%
                                </span>
                            )}
                            <span>Son 30 güne göre değişim</span>
                        </p>
                    </div>
                </div>
            </div>
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-3 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Aktif Organizasyonlar</p>
                                <h6 className="mb-0">{stats.activeOrganizations?.toLocaleString('tr-TR') || 0}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-info rounded-circle d-flex justify-content-center align-items-center">
                                <Icon
                                    icon="fluent:people-20-filled"
                                    className="text-white text-2xl mb-0"
                                />
                            </div>
                        </div>
                        <p className="fw-medium text-sm text-primary-light mt-12 mb-0 d-flex align-items-center gap-2">
                            {stats.activeOrganizationsPercent !== 0 && (
                                <span className={`d-inline-flex align-items-center gap-1 ${stats.activeOrganizationsPercent >= 0 ? 'text-success-main' : 'text-danger-main'}`}>
                                    <Icon icon={stats.activeOrganizationsPercent >= 0 ? "bxs:up-arrow" : "bxs:down-arrow"} className="text-xs" />
                                    {Math.abs(stats.activeOrganizationsPercent)}%
                                </span>
                            )}
                            <span>Son 30 güne göre değişim</span>
                        </p>
                    </div>
                </div>
            </div>
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-4 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Toplam Randevular</p>
                                <h6 className="mb-0">{stats.totalAppointments?.toLocaleString('tr-TR') || 0}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-success-main rounded-circle d-flex justify-content-center align-items-center">
                                <Icon
                                    icon="solar:calendar-bold"
                                    className="text-white text-2xl mb-0"
                                />
                            </div>
                        </div>
                        <p className="fw-medium text-sm text-primary-light mt-12 mb-0 d-flex align-items-center gap-2">
                            {stats.totalAppointmentsPercent !== 0 && (
                                <span className={`d-inline-flex align-items-center gap-1 ${stats.totalAppointmentsPercent >= 0 ? 'text-success-main' : 'text-danger-main'}`}>
                                    <Icon icon={stats.totalAppointmentsPercent >= 0 ? "bxs:up-arrow" : "bxs:down-arrow"} className="text-xs" />
                                    {Math.abs(stats.totalAppointmentsPercent)}%
                                </span>
                            )}
                            <span>Son 30 güne göre değişim</span>
                        </p>
                    </div>
                </div>
            </div>
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-5 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Tamamlanan</p>
                                <h6 className="mb-0">{stats.completedAppointments?.toLocaleString('tr-TR') || 0}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-success-main rounded-circle d-flex justify-content-center align-items-center">
                                <Icon
                                    icon="solar:check-circle-bold"
                                    className="text-white text-2xl mb-0"
                                />
                            </div>
                        </div>
                        <p className="fw-medium text-sm text-primary-light mt-12 mb-0 d-flex align-items-center gap-2">
                            {stats.completedAppointmentsPercent !== 0 && (
                                <span className={`d-inline-flex align-items-center gap-1 ${stats.completedAppointmentsPercent >= 0 ? 'text-success-main' : 'text-danger-main'}`}>
                                    <Icon icon={stats.completedAppointmentsPercent >= 0 ? "bxs:up-arrow" : "bxs:down-arrow"} className="text-xs" />
                                    {Math.abs(stats.completedAppointmentsPercent)}%
                                </span>
                            )}
                            <span>Son 30 güne göre değişim</span>
                        </p>
                    </div>
                </div>
            </div>
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-6 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Toplam Gelir</p>
                                <h6 className="mb-0">₺{stats.totalRevenue?.toLocaleString('tr-TR') || 0}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-warning rounded-circle d-flex justify-content-center align-items-center">
                                <Icon
                                    icon="solar:wallet-bold"
                                    className="text-white text-2xl mb-0"
                                />
                            </div>
                        </div>
                        <p className="fw-medium text-sm text-primary-light mt-12 mb-0 d-flex align-items-center gap-2">
                            {stats.totalRevenuePercent !== 0 && (
                                <span className={`d-inline-flex align-items-center gap-1 ${stats.totalRevenuePercent >= 0 ? 'text-success-main' : 'text-danger-main'}`}>
                                    <Icon icon={stats.totalRevenuePercent >= 0 ? "bxs:up-arrow" : "bxs:down-arrow"} className="text-xs" />
                                    {Math.abs(stats.totalRevenuePercent)}%
                                </span>
                            )}
                            <span>Son 30 güne göre değişim</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UnitCountOne
